import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { getUser } from 'Utils/UserCookie';
import { filterByEventId, initPaymentIframe } from 'Utils/Payment';
import { attachEventListener, removeEventListener } from 'Utils/Browser';
import { trackFormError } from 'Utils/Analytics';
import { updateTaxByZip } from 'State/Checkout/CheckoutActions';

import './PaymentFrame.css';

// payment iframe events names
const PAYMENT_FORM_FIELD_CHANGE = 'PAYMENT_FORM_FIELD_CHANGE';
const TAX_UPDATED = 'TAX_UPDATED';
const VALID_PAYMENT_FORM = 'VALID_PAYMENT_FORM';
const ONFOCUS_DATA = 'ONFOCUS_DATA';

class PaymentFrame extends Component {
  state = {
    accessToken: '',
  };

  componentDidMount() {
    const { accessToken } = getUser();
    this.setState({ accessToken }, () => {
      attachEventListener('message', this.paymentFrameEventListener);
      initPaymentIframe();
    });
  }

  componentWillUnmount() {
    removeEventListener('message', this.paymentFrameEventListener);
    console.debug(`Payment Frame: unmount`);
  }

  get isCvvRequired() {
    const { showCVV } = this.props;
    return showCVV ? 1 : 0;
  }

  paymentFrameEventListener = (eventData) => {
    const { updateTaxByZip, onValidate, formName, onExpiryError, resetFormError, setErrorMessage } = this.props;

    const { eventId, data } = filterByEventId(eventData);

    if (eventId && eventId === ONFOCUS_DATA) {
      // When the form is re-focused to fix errors, clear error. NATCOM-465
      resetFormError();
      if (setErrorMessage) {
        setErrorMessage('');
      }
    }

    if (eventId) {
      if (eventId === PAYMENT_FORM_FIELD_CHANGE) {
        if (!data.isValid) {
          const { errorDescription } = data;
          trackFormError(formName, {
            message: errorDescription,
            status: 1000,
          });
        }

        if (data.fieldName === 'expiryDate') {
          onExpiryError(!data.isValid);
        }
      }

      if (eventId === VALID_PAYMENT_FORM && onValidate) {
        onValidate(data.isValid);
      }

      if (eventId === TAX_UPDATED) {
        updateTaxByZip(data);
      }
    }
  };

  createFrame = () => ({
    __html: `<iframe class="EvPaymentFrame" title="Payment Form" name="paymentpage" frameborder="0" scrolling="no" />`,
  });

  renderPaymentForm = () => {
    const {
      evPaymentFrameUrl,
      rootDomain,
      user,
      selectedPlan,
      activeSubscriptionId,
      isPlanSelected,
      updatePaymentServiceId,
    } = this.props;
    const [, domainName] = rootDomain.split('https://');
    const { accessToken } = this.state;
    const { profileId } = user;

    let selectedPlanId = '';
    let promotionId = '';
    if (isPlanSelected && selectedPlan) {
      const { planId, promotionID } = selectedPlan;
      selectedPlanId = planId;
      promotionId = promotionID;
    }
    const serviceId = updatePaymentServiceId || selectedPlanId || activeSubscriptionId;

    return (
      <Fragment>
        <form id="evPaymentIframe" target="paymentpage" action={evPaymentFrameUrl} method="post">
          <input type="hidden" name="serviceId" value={serviceId} />
          <input type="hidden" name="isCvvRequired" value={this.isCvvRequired} />
          <input type="hidden" name="domainName" value={domainName} />
          <input type="hidden" name="cpCustomerID" value={profileId} />
          <input type="hidden" name="accessToken" value={accessToken} />
          <input type="hidden" name="promotionId" value={promotionId} />
        </form>
        <div dangerouslySetInnerHTML={this.createFrame()} className="EvPaymentFrameWrapper" />
      </Fragment>
    );
  };

  render() {
    return this.renderPaymentForm();
  }
}

const mapStateToProps = ({
  user,
  appConfig: {
    defaultConfig: { evPaymentFrameUrl, rootDomain, showCVV },
  },
  plans: { isPlanSelected, selectedPlan },
  subscription: { activeSubscriptionId },
}) => ({
  evPaymentFrameUrl,
  user,
  isPlanSelected,
  rootDomain,
  activeSubscriptionId,
  showCVV,
  selectedPlan,
});

const mapDispatchToProps = {
  updateTaxByZip,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentFrame);
